import { render } from "./BottlesChoose.vue?vue&type=template&id=325efd16&scoped=true"
import script from "./BottlesChoose.vue?vue&type=script&lang=js"
export * from "./BottlesChoose.vue?vue&type=script&lang=js"

import "./BottlesChoose.vue?vue&type=style&index=0&id=325efd16&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325efd16"]])

export default __exports__